import { render, staticRenderFns } from "./P05.vue?vue&type=template&id=0e317574&scoped=true"
import script from "./P05.ts?vue&type=script&lang=ts&external"
export * from "./P05.ts?vue&type=script&lang=ts&external"
import style0 from "./P05.vue?vue&type=style&index=0&id=0e317574&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e317574",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e317574')) {
      api.createRecord('0e317574', component.options)
    } else {
      api.reload('0e317574', component.options)
    }
    module.hot.accept("./P05.vue?vue&type=template&id=0e317574&scoped=true", function () {
      api.rerender('0e317574', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/ProcessesForms/pages/P05/P05.vue"
export default component.exports